export const SELECT_OPTGROUP_EMPTY_VALUE_PREFIX = '__select_optgroup_empty__'

export const selectOptgroupEmptyValue = (groupIndex: number) =>
  `${SELECT_OPTGROUP_EMPTY_VALUE_PREFIX}${groupIndex}`

export const isSelectOptgroupEmptyValue = (value: unknown) =>
  typeof value === 'string' &&
  value.startsWith(SELECT_OPTGROUP_EMPTY_VALUE_PREFIX)
